import CategoriseLitterPage from "pages/photo/pages/CategorisePhotoPage";

export default function CategorisePhotoRoute() {
  return <CategoriseLitterPage />;
}
